import { HttpError } from '@luminovo/api-contracts';
import { httpQuery } from '@luminovo/data-stack';
import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import type { JSX } from 'react';

import { isAwardScenario } from '@/areas/negotiations/Negotiations/model/awardScenario';
import { NegotiationScenarioDetailPage } from '@/areas/negotiations/Negotiations/NegotiationScenarioDetailPage/NegotiationScenarioDetailPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    loader: async ({ context: { queryClient }, params: { negotiationId, sourcingScenarioId } }) => {
        // Asks with the query the page reads it with, so the page doesn't ask again.
        const {
            items: [scenario],
        } = await queryClient
            .ensureQueryData(httpQuery('POST /sourcing-scenarios/bulk', { requestBody: { ids: [sourcingScenarioId] } }))
            .catch((error: unknown) => {
                throw error instanceof HttpError && error.status === 404 ? notFound() : error;
            });
        if (scenario === undefined) {
            throw notFound();
        }
        // Award scenarios aren't shown as scenarios anywhere, so a link to one is stale: open the awarding of its
        // demand group, which is what it represents.
        if (isAwardScenario(scenario)) {
            throw redirect({
                to: '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding',
                params: { negotiationId, demandGroupId: scenario.demand_group_id },
                replace: true,
            });
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <NegotiationScenarioDetailPage {...pathParams} />;
}
